(function($) {
	'use strict';
	$.fn.Slide__InsightsTrigger = function() {
		this.each(function() {

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this);


			// Listen for click
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Disable others
				$.HTML.removeClass('slide-products-on');

				// Set user preference
				var pref = $.HTML.hasClass('slide-insights-on') ? false : 'slide_insights';
				$.Globals.ajax( 'scspaces_set_user_preference', { 'which' : 'show_on_slide', 'pref' : pref } );

				// Set the class
				$.HTML.toggleClass( 'slide-insights-on' );

			});


		});
		return this;
	};
}(jQuery));
